/* eslint-disable max-len */
export const globalAdminMessages = {
    'GlobalAdmin.Application.added': 'Application added.',
    'GlobalAdmin.Application.addNew': 'Add New Application',
    'GlobalAdmin.Application.deleted': 'Application deleted.',
    'GlobalAdmin.Application.disabled': 'Application disabled.',
    'GlobalAdmin.Application.notAdded': 'Application could not be added.',
    'GlobalAdmin.Application.notDeleted': 'Application could not be deleted.',
    'GlobalAdmin.Application.notUpdated': 'Unable to update category.',
    'GlobalAdmin.Application.updated': 'Application category updated.',
    'GlobalAdmin.Application.workatoProvider': 'Workato Provider',
    'GlobalAdmin.Applications.add_identifiers': 'Add Identifiers',
    'GlobalAdmin.Applications.add_username_refs': 'Add Username Refs',
    'GlobalAdmin.Applications.added': 'Applications added.',
    'GlobalAdmin.Applications.app_deleted': 'Application Deleted.',
    'GlobalAdmin.Applications.appSettingsNotSaved':
        'Application settings could not be saved.',
    'GlobalAdmin.Applications.appSettingsSaved': 'Application settings saved.',
    'GlobalAdmin.Applications.base_name': 'Base Name',
    'GlobalAdmin.Applications.bulkEdit_one': 'Bulk edit {{count}} application',
    'GlobalAdmin.Applications.bulkEdit_other':
        'Bulk edit {{count}} applications',
    'GlobalAdmin.Applications.date_app_found': 'Date Application Found',
    'GlobalAdmin.Applications.disable_app':
        'Disabled application. It will not populate in Auvik SaaS Management.',
    'GlobalAdmin.Applications.error_add':
        'Unable to save application, error occurred.',
    'GlobalAdmin.Applications.error_delete':
        'Unable to delete application, it is likely there is already tenant or application links existing.',
    'GlobalAdmin.Applications.error_disable': 'Unable to disable application.',
    'GlobalAdmin.Applications.excludeDisabledApps':
        'Exclude Disabled Applications',
    'GlobalAdmin.Applications.global_usage': 'Global Usage: {{usage}}',
    'GlobalAdmin.Applications.icon': 'Icon',
    'GlobalAdmin.Applications.id': '<prefix>ID: </prefix>{{id}}',
    'GlobalAdmin.Applications.identifier': 'Identifier',
    'GlobalAdmin.Applications.identifierRegex': 'Regex',
    'GlobalAdmin.Applications.identifiers': 'Identifiers',
    'GlobalAdmin.Applications.merge.confirmation.alertText':
        'This action cannot be undone.',
    'GlobalAdmin.Applications.merge.confirmation.description': `This will merge <bold>{{fromApp}}</bold> into <bold>{{toApp}}</bold>
        and will transfer all associated data (such as identifiers, tenant apps, user apps, app logs, etc.) to <bold>{{toApp}}</bold>.
        <br />
        <br />
        <bold>{{fromApp}}</bold> will then be deleted.
        <br />
        <br />
        Are you sure you want to continue?`,
    'GlobalAdmin.Applications.merge.confirmation.title': 'Merge Applications',
    'GlobalAdmin.Applications.merge_app_into': 'Merge {{appName}} Into',
    'GlobalAdmin.Applications.mergeError': 'Issue merging applications.',
    'GlobalAdmin.Applications.mergeSubmitted':
        'Merge submitted to be processed.',
    'GlobalAdmin.Applications.notSaved': 'Unable to save application.',
    'GlobalAdmin.Applications.open_google_search': 'Open Google Search',
    'GlobalAdmin.Applications.open_url': 'Open URL',
    'GlobalAdmin.Applications.p_finance': 'P / Finance',
    'GlobalAdmin.Applications.p_other': 'P / Other',
    'GlobalAdmin.Applications.p_shopping': 'P / Shopping',
    'GlobalAdmin.Applications.ref': 'Ref',
    'GlobalAdmin.Applications.reset_pull_details': 'Reset Pull Details',
    'GlobalAdmin.Applications.settingsSaved': 'Applications settings saved.',
    'GlobalAdmin.Applications.title': 'Application Catalog',
    'GlobalAdmin.Applications.type': 'Type',
    'GlobalAdmin.Applications.urlNotvalid': '{{baseName}} is not a valid URL.',
    'GlobalAdmin.Applications.usernameRefs': 'Username Refs',
    'GlobalAdmin.Applications.usernameRefs.added': 'Username Refs added.',
    'GlobalAdmin.Applications.usernameRefs.deleted': 'Username Refs deleted.',
    'GlobalAdmin.Applications.usernameRefs.notAdded':
        'Username Refs could not be added.',
    'GlobalAdmin.Applications.usernameRefs.notDeleted':
        'Username Refs could not be deleted.',
    'GlobalAdmin.Applications.usernameRefs.notUpdated':
        'Username Refs could not be updated.',
    'GlobalAdmin.Applications.usernameRefs.saved': 'Username Refs',
    'GlobalAdmin.Applications.usernameRefs.updated': 'Username Refs updated.',
    'GlobalAdmin.Applications.webhookToken':
        '<prefix>Token: </prefix>{{webhookToken}}',
    'GlobalAdmin.Category.added': 'Category added.',
    'GlobalAdmin.Category.notAdded': 'Category could not be added.',
    'GlobalAdmin.Category.notSaved': 'Category could not be saved.',
    'GlobalAdmin.Category.saved': 'Category saved.',
    'GlobalAdmin.confirm_purge_title': 'Are you ABSOLUTELY sure?',
    'GlobalAdmin.Publisher.addPublisher': 'Add Publisher',
    'GlobalAdmin.Publisher.areYouSure': 'Are you sure?',
    'GlobalAdmin.Publisher.choose': 'Choose a publisher',
    'GlobalAdmin.Publisher.create': 'Add new publisher',
    'GlobalAdmin.Publisher.create.fieldErrors.name': 'Name cannot be empty.',
    'GlobalAdmin.Publisher.create.name': 'Publisher Name',
    'GlobalAdmin.Publisher.deleteModalMessage':
        'This will delete {{publisherName}}, do you want to continue?',
    'GlobalAdmin.Publisher.deletePublisher': 'Delete Publisher',
    'GlobalAdmin.Publisher.editPublisher': 'Edit Publisher',
    'GlobalAdmin.Publisher.publisherAdded': 'Publisher was successfully added.',
    'GlobalAdmin.Publisher.publisherDeleted':
        'Publisher was succesfully deleted.',
    'GlobalAdmin.Publisher.publisherNotAdded': 'Unable to add publisher.',
    'GlobalAdmin.Publisher.publisherNotDeleted': 'Unable to delete publisher.',
    'GlobalAdmin.Publisher.publisherNotUpdated': 'Unable to update publisher.',
    'GlobalAdmin.Publisher.publisherUpdated':
        'Publisher was succesfully updated.',
    'GlobalAdmin.purge_tenant': 'Delete & Purge',
    'GlobalAdmin.show_purge': 'Show Delete/Purge Button',
    'GlobalAdmin.Tenant.created_via_anm': 'ANM',
    'GlobalAdmin.Tenant.createPartner': 'Create Partner',
    'GlobalAdmin.Tenant.Edit.Actions.enableAgentHandlingExtensionActivity':
        'Enable agent handling of browser extension activity',
    'GlobalAdmin.Tenant.Edit.Actions.hubType.label': 'Hub Type',
    'GlobalAdmin.Tenant.Edit.Actions.hubType.none': 'None',
    'GlobalAdmin.Tenant.Edit.Actions.hubType.premium': 'Premium',
    'GlobalAdmin.Tenant.Edit.Actions.PartnerSettings':
        'Additional Partner Settings',
    'GlobalAdmin.Tenant.Edit.Actions.removePoweredByBranding':
        'Remove Powered By Auvik SaaS Management branding',
    'GlobalAdmin.Tenant.Edit.Actions.submitButton': 'Update tenant settings',
    'GlobalAdmin.Tenant.Edit.Actions.successfullySavedTenant':
        'Successfully saved tenant.',
    'GlobalAdmin.Tenant.Edit.Actions.successfullyUpdatedFeatureFlags':
        'Successfully updated feature flags.',
    'GlobalAdmin.Tenant.Edit.Actions.title': 'Tenant Settings',
    'GlobalAdmin.Tenant.Edit.Actions.unabletoSaveTenantSettings':
        'Unable to save tenant settings.',
    'GlobalAdmin.Tenant.Edit.Actions.unabletoUpdateFeatureFlags':
        'Unable to update feature flags.',
    'GlobalAdmin.Tenant.Edit.AddAdmin.adminEmail': 'Admin Email',
    'GlobalAdmin.Tenant.Edit.AddAdmin.button': 'Add Admin',
    'GlobalAdmin.Tenant.Edit.AddAdmin.error': 'Error adding admin user.',
    'GlobalAdmin.Tenant.Edit.AddAdmin.success':
        'Successfully added admin user.',
    'GlobalAdmin.Tenant.Edit.AddAdmin.title': 'Add Admin User',
    'GlobalAdmin.Tenant.Edit.dangerZone.title': 'Danger Zone',
    'GlobalAdmin.Tenant.Edit.dangerZone.warning':
        'The actions in this section are permanent and cannot be undone.',
    'GlobalAdmin.Tenant.Edit.LinkAnm.formFields.tenantDomain':
        'ANM Tenant Domain Prefix',
    'GlobalAdmin.Tenant.Edit.LinkAnm.formFields.tenantID': 'ANM Tenant ID',
    'GlobalAdmin.Tenant.Edit.LinkAnm.formFields.tenantType': 'Tenant Type',
    'GlobalAdmin.Tenant.Edit.LinkAnm.formFields.tenantType.options.notSet':
        'Not set',
    'GlobalAdmin.Tenant.Edit.LinkAnm.info.1':
        "To link to an ANM tenant, enter the client’s ANM Tenant ID, ANM domain prefix, and set Tenant Type to 'ANM'.",
    'GlobalAdmin.Tenant.Edit.LinkAnm.info.2':
        'Note: The tenant link is not complete until it is linked in the ANM database. Please notify the PACT team of the client’s ASM tenant ID to complete the linking process.',
    'GlobalAdmin.Tenant.Edit.LinkAnm.info.3': 'ASM Tenant ID',
    'GlobalAdmin.Tenant.Edit.LinkAnm.submitButton': 'Link Tenant',
    'GlobalAdmin.Tenant.Edit.LinkAnm.title': 'Link ANM tenant',
    'GlobalAdmin.Tenant.Edit.purge.button': 'Send purge request',
    'GlobalAdmin.Tenant.Edit.purge.confirm.description':
        'This request will delete the tenant and all of its data. If this tenant is a partner, all of its associated client tenants (and their data) will also be removed.',
    'GlobalAdmin.Tenant.Edit.purge.description':
        'Send a request to purge the tenant and all of its associated tenants and data.',
    'GlobalAdmin.Tenant.Edit.purge.descriptionClient':
        'All of the Tenant’s data will be PURGED.',
    'GlobalAdmin.Tenant.Edit.purge.descriptionPartner':
        'All of the Partner’s data will be PURGED, as well as their clients.',
    'GlobalAdmin.Tenant.Edit.purge.title': 'Purge Tenant',
    'GlobalAdmin.Tenant.Edit.purgeError': 'Unable to purge tenant.',
    'GlobalAdmin.Tenant.Edit.purgeSubmitted':
        'Purge submitted to be processed.',
    'GlobalAdmin.Tenant.Edit.redaction.button': 'Send redaction request',
    'GlobalAdmin.Tenant.Edit.redaction.confirm.description':
        'This request will retroactively redact any personal data from areas such as security logs, application accounts and browser aliases. This action cannot be undone.',
    'GlobalAdmin.Tenant.Edit.redaction.description':
        'Send a request to retroactively redact personal email data for the tenant.',
    'GlobalAdmin.Tenant.Edit.redaction.notEnabledTooltip':
        'This tenant does not have personal data obfuscation enabled. We are unable to request redaction.',
    'GlobalAdmin.Tenant.Edit.redaction.title':
        'Redact Personal Data Retroactively',
    'GlobalAdmin.Tenant.Edit.redactionError':
        'Error submitting redaction request.',
    'GlobalAdmin.Tenant.Edit.redactionSubmitted':
        'Redaction request submitted.',
    'GlobalAdmin.Tenant.Edit.UpdateManifest.title': 'Update Workato Manifest',
    'GlobalAdmin.Tenant.EditTenant': 'Edit',
    'GlobalAdmin.Tenant.FeatureFlag.saasOps.Description':
        'Enables SaaS Ops Beta - When enabled, Users can then set up SaaS Ops integrations under the Client > Utilities > SaaS Ops menu.',
    'GlobalAdmin.Tenant.FeatureFlag.saasOps.Title': 'Saas Ops',
    'GlobalAdmin.Tenant.FeatureFlag.submitButton': 'Update Feature Flags',
    'GlobalAdmin.Tenant.FeatureFlags.title': 'Feature Flags',
    'GlobalAdmin.Tenant.hubType': 'Hub Type',
    'GlobalAdmin.Tenant.isPartner': 'Is Partner?',
    'GlobalAdmin.Tenant.noAdminUser': 'There is no admin user on this tenant.',
    'GlobalAdmin.Tenant.partnerCreatedSuccessfully':
        'Partner created successfully.',
    'GlobalAdmin.Tenant.partnersOnly': 'Partners Only',
    'GlobalAdmin.Tenant.revokedRemoteAccess':
        'This tenant has disabled support access.',
    'GlobalAdmin.Tenant.TrialEndDate.label': 'Trial End Date',
    'GlobalAdmin.Tenant.unabletoCreateAdminUserUnderNewPartner':
        'Unable to create admin user under new partner.',
    'GlobalAdmin.Tenant.unabletoCreatePartner': 'Unable to create partner.',
    'GlobalAdmin.Tenant.updateTenant': 'Update Tenant'
};
